import { PopoverArrow as ChakraPopoverArrow } from '@chakra-ui/react';

import { PopoverArrowProps } from './popover-arrow.types';

export default function PopoverArrow(props: PopoverArrowProps) {
  return <ChakraPopoverArrow {...props} />;
}
